import type {
  AnnotationBridgeStore,
  AnnotationEntry,
  BuiltInDrawKind,
} from '@geosoft/viewer-sdk';

const BUILT_IN_MODES: BuiltInDrawKind[] = [
  'point',
  'line',
  'polygon',
  'rectangle',
  'circle',
  'select',
];

export interface CreatePointAnnotationInput {
  readonly lonLat: readonly [number, number];
  readonly tenantId: string;
  readonly projectId: string;
  readonly actor: string;
  readonly label?: string;
  readonly now?: Date;
  readonly id?: string;
}

export function listAnnotationModes(): BuiltInDrawKind[] {
  return [...BUILT_IN_MODES];
}

export function createPointAnnotation(input: CreatePointAnnotationInput): AnnotationEntry {
  const now = (input.now ?? new Date()).toISOString();
  const [lon, lat] = input.lonLat;

  return {
    id: input.id ?? createAnnotationId(input.now ?? new Date()),
    kind: 'point',
    geometry: {
      type: 'Point',
      coordinates: [lon, lat],
    },
    properties: {
      label: input.label ?? `Annotation at ${lon.toFixed(4)}, ${lat.toFixed(4)}`,
      source: 'f7-annotation-plugin',
    },
    createdBy: input.actor,
    createdAt: now,
    updatedAt: now,
    style: {
      color: '#2563eb',
    },
  };
}

export async function persistPointAnnotation(
  store: AnnotationBridgeStore,
  input: CreatePointAnnotationInput,
): Promise<AnnotationEntry> {
  const annotation = createPointAnnotation(input);
  await store.appendAnnotation(input.tenantId, input.projectId, annotation, input.actor);
  return annotation;
}

function createAnnotationId(now: Date): string {
  // Placeholder until the project-sdk ULID helper ships. Prefix keeps these
  // bridge ids distinct and sortable enough for local offline use.
  return `ann-${now.getTime().toString(36)}`;
}
